import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

//context

// theme
import { useTheme } from "../../hooks/";

const Box = ({
  themeColor,
  backgroundColor,
  themeAware,
  children,
  debug,
  style,
  ...rest
}) => {
  const { themeContext, theme } = useTheme();
  const { activeTheme } = themeContext;

  const styles = {
    debug: {
      borderWidth: 1,
      borderColor: activeTheme === "midnight" ? "white" : "black",
    },

    themeAware: {
      backgroundColor: theme.colors[themeContext.activeTheme][themeColor],
    },

    notThemeAware: {
      backgroundColor:
        backgroundColor === "background" ? "white" : backgroundColor,
    },
  };

  const mergedStyles = [
    themeAware && styles.themeAware,
    debug && styles.debug,
    !themeAware && styles.notThemeAware,
    style,
  ];

  const clean = mergedStyles.filter((item) => {
    return item !== false;
  });

  const final = clean.reduce(function (result, current) {
    return Object.assign(result, current);
  }, {});

  return (
    <View style={final} {...rest}>
      {children}
    </View>
  );
};

Box.defaultProps = {
  backgroundColor: "background",
  themeColor: "background",
  themeAware: true,
  debug: false,
};

Box.propTypes = {
  backgroundColor: PropTypes.string,
  themeColor: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  themeAware: PropTypes.bool,
  debug: PropTypes.bool,
  style: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({})]),
};

const View = styled.div``;

export default Box;
